export default __webpack_public_path__ + "static/media/25.bad6e6e2.png";